import entityReducer from "./unitListingEntityReducer";

const reducers = { entities: entityReducer };

export default reducers;
